import cx from 'classnames'
import React from 'react'

import Link, { Appearance, Size } from '@cinch/oxd-components/link/src'

import styles from './dual-cta.module.css'

interface CTA {
  label: string
  to: string
}

interface DualCtaProps {
  ctas: [CTA, CTA]
  className?: string
}

const DualCta: React.FC<DualCtaProps> = ({ ctas, className }) => {
  return (
    <div className={cx(styles.actions, className)}>
      <Link appearance={Appearance.primaryButton} to={ctas[0].to || '/'} className={styles.button} size={Size.large}>
        {ctas[0].label}
      </Link>
      <Link
        appearance={Appearance.primaryButton}
        to={ctas[1].to || '/find-your-car'}
        className={styles.button}
        size={Size.large}
      >
        {ctas[1].label}
      </Link>
    </div>
  )
}

export default DualCta
